import React from 'react';
import classes from './BtnTransparent.module.scss';
const BtnTransparent = ({ text, fullWidth, type, onClick, white, grey, icon, loading, style }) => {
    var _a;
    const classList = (_a = `${classes.btnTransparent} ${fullWidth !== undefined && fullWidth ? classes.btnFull : ''} ${white ? classes.white : ''} ${grey ? classes.grey : ''} ${loading ? classes.loading : ''}`) === null || _a === void 0 ? void 0 : _a.trim();
    return (React.createElement("button", { style: style, type: type, onClick: onClick, className: classList },
        icon && icon,
        text));
};
export default BtnTransparent;
